export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'c0ba901', dateTime: 1791494935422 };